export const FETCH_MY_WISHES_PAGE = "MyWishes/fetchMyWishesPage";
export const SET_HAS_MORE_WISHES = "MyWishes/setHasMore";
export const SET_WISHES_LAST_PAGE = "MyWishes/setLastPageDownloaded";
export const RECEIVE_MY_WISHES_PAGE = "MyWishes/receiveMyWishesPage";
export const SET_WISHES_LOADING = "MyWishes/setWishesLoading";
export const API_ERROR = "MyWishes/ApiError";
export const RESET = "MyWishes/RESET";
export const SET_WISHES_TO_DISPLAY = "MyWishes/toggleWishesToDisplaay";
export const SET_WISH_STATE = "MyWishes/setState";
